<alaris-dialog
	[closeAction]="close.bind(this)"
	[confirmAction]="confirm.bind(this)"
	[loading$]="rulesService.loading$"
	[confirmButtonText]="'gl.delete'"
	size="md"
	class="removingDialog">
	<h3 slot="header">
		<app-circle-warning></app-circle-warning>
		<div>
			{{ 'rules.removingDialogTitle' | translate }}
		</div>
	</h3>
	<div slot="content">
		<p>
			{{ 'rules.removingDialog' | translate }}
			<br />
			<strong>{{ data.rule.ruleId }} - {{ data.rule.name }}</strong>
		</p>
	</div>
</alaris-dialog>
